// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"848":"f83661df","916":"04b616a7"}[chunkId] + ".js";
};